import type { RefObject } from "react";
import type { WeekColumn } from "@/utils/weekUtils";
import { isoKey } from "@/utils/weekUtils";
import type { SortDirection } from "./MakersTable";

interface MakersWeekHeaderRowProps {
  weeks: WeekColumn[];
  sortDirection: SortDirection;
  onSort: () => void;
  timelineRef?: RefObject<HTMLDivElement | null>;
}

export function MakersWeekHeaderRow({ weeks, sortDirection, onSort, timelineRef }: MakersWeekHeaderRowProps) {
  return (
    <div className="week-header-row week-header-row--makers">
      <div className="week-header-row__fixed" >
        <button
          className="makers-table__sort-button"
          onClick={() => onSort()}
          type="button"
        >
          Name
          <span className="makers-table__sort-indicator">
            {sortDirection === "asc" ? "↑" : "↓"}
          </span>
        </button>
      </div>
      <div className="week-header-row__timeline" ref={timelineRef}>
        <div
          className="timeline-grid"
          style={{ gridTemplateColumns: `repeat(${weeks.length}, 64px)` }}
        >
          {weeks.map((week) => (
            <div
              key={isoKey(week)}
              className="timeline-cell timeline-cell--header"
            >
              <span className="timeline-cell__label">{week.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

